import { fromJS } from 'immutable';

import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_REGISTER_GST_STATE,
  CLOSE_BSB_NOTICE,
  RESET_TUGO_BANK_FIELDS,
  RESET_ADDRESS,
} from './constants';

import {
  GET_BANK_SUCCESS,
  GETTING_BANK,
  GET_BANK_ERROR,
} from '../../FastCover/constants';

export const TUGO_DEFAULT_COUNTRY = { id: 39, name: 'Canada' };

// The initial state of the App
const initialState = fromJS({
  form: {
    abn: '',
    claimITC: 'false',
    nameOfBank: '',
    branch: '',
    bsbNumber: '',
    institutionNumber: '',
    accountNumber: '',
    accountHolder: '',
    registerForGSTPurpose: 'false',
    percentageOfGST: '',
    bsbCannotBeVerified: false,
    isBsbValid: false,
    otherInsurance: 'false',
    provideDetails: '',
    // V2 fields
    paymentTo: 'Member',
    country: {
      id: TUGO_DEFAULT_COUNTRY.id,
      label: TUGO_DEFAULT_COUNTRY.name,
      value: TUGO_DEFAULT_COUNTRY.name,
    },
    isCheckPayment: false,
    // Trawick-style bank fields (for non-Canada countries)
    bankTypeCode: 'Bank Code',
    bankCodeOrRoutingNumber: '',
    bank: '',
    bankAddress: '',
    bankSuburbOrCity: '',
    bankPostcode: '',
    bankBranch: '',
    bankAccountName: '',
    bankAccountNumber: '',
    swiftCode: '',
    iban: '',
    paymentTypeOptions: [],
    isValidate: false,
    // Check address fields
    paymentVia: 'EFT',
    title: '',
    firstName: '',
    lastName: '',
    addressLine1: '',
    addressLine2: '',
    state: '',
    city: '',
    postalZipCode: '',
    mobile: '',
  },
  errors: [],
  dirty: false,
  bsbValidating: false,
  showBSBNotice: false,
});

const initialRegisterForGstState = {
  form: {
    registerForGSTPurpose: 'false',
    abn: '',
    claimITC: 'false',
    percentageOfGST: '',
  },
};

const initialBankInfo = {
  form: {
    nameOfBank: '',
    branch: '',
    institutionNumber: '',
  },
};

const initialAddress = {
  form: {
    addressLine1: '',
    addressLine2: '',
    firstName: '',
    mobile: '',
    lastName: '',
    title: '',
    state: '',
    country: null,
    postalZipCode: '',
    city: '',
  },
};

const initialTugoBankFields = {
  form: {
    // Reset Canada bank fields
    nameOfBank: '',
    branch: '',
    bsbNumber: '',
    institutionNumber: '',
    accountNumber: '',
    accountHolder: '',
    bsbCannotBeVerified: false,
    isBsbValid: false,
    // Reset Trawick bank fields
    bankTypeCode: 'Bank Code',
    bankCodeOrRoutingNumber: '',
    bank: '',
    bankAddress: '',
    bankSuburbOrCity: '',
    bankPostcode: '',
    bankBranch: '',
    bankAccountName: '',
    bankAccountNumber: '',
    swiftCode: '',
    iban: '',
    isValidate: false,
  },
};

function stepAppsureBankDetailsReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      if (properties[1] === 'bsbCannotBeVerified' && !action.value) {
        return state.mergeDeep(initialBankInfo).setIn(properties, action.value);
      }
      return state.setIn(properties, action.value);
    case LOAD:
      if (action.payload) {
        return fromJS({ form: action.payload, errors: [] });
      }
      return initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    case RESET_REGISTER_GST_STATE:
      return state.mergeDeep(initialRegisterForGstState);
    case GET_BANK_SUCCESS:
      return state.mergeDeep({ form: action.bankInfo, bsbValidating: false });
    case GETTING_BANK:
      return state.merge({ bsbValidating: action.value });
    case GET_BANK_ERROR:
      return state.merge({ showBSBNotice: true });
    case CLOSE_BSB_NOTICE:
      return state.merge({ showBSBNotice: false });
    case RESET_TUGO_BANK_FIELDS:
      return state.mergeDeep(initialTugoBankFields);
    case RESET_ADDRESS:
      return state.mergeDeep(initialAddress);
    default:
      return state;
  }
}

export default stepAppsureBankDetailsReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Appsure.StepBankDetails/reducer.js